import { Tabs } from 'antd';
import GeneralHeader from 'components/common/GeneralHeader';
import AbsenceTypesTab from 'components/tabs-components/absence_types';
import { useFormik } from 'formik';
import useMember from 'hooks/useMember';
import useNotice from 'hooks/useNotice';
import { useState } from 'react';
import * as Yup from 'yup';
let accruing_conditions = [];
for (let i = 1; i <= 12; i++) {
  // let date = new Date();
  // date.setFullYear(2023, i - 1, 1);
  // let daysInMonth = new Date(
  //   date.getFullYear(),
  //   date.getMonth() + 1,
  //   0,
  // ).getDate();

  let item = {
    month: i,
    day: 1,
    balance: 0.0,
    reset_counter: false,
  };
  accruing_conditions.push(item);
}
const formSchema = Yup.object().shape({
  calendar_color: Yup.string().required('Calendar color is required'),
  font_color: Yup.string().required('Font color is required'),
  calendar_code: Yup.string().required('Calendar code is required'),
  name: Yup.string().required('Name is required'),
});

const NewAbsenceTypes = () => {
  const [state, setState] = useState({
    finalData: {
      accruing_type: 'free',
      accruing_conditions: accruing_conditions,
      balance: -1,
      calendar_color: '',
      font_color: '',
      calendar_code: '',
      name: '',
      description: '',
      long_description: '',
      comment: '',
      french_description: '',
      french_long_description: '',
      french_comment: '',
    },
  });
  const { finalData } = state;
  const { successNotification, error, errorType } = useNotice();
  const { createStaffTypes } = useMember();
  const [errorName, setErrorName] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const addData = (data: any) => {
    setState((pre) => ({
      ...pre,
      finalData: Object.assign(finalData, data),
    }));
  };

  const formik = useFormik({
    initialValues: {
      accruing_type: 'free',
      accruing_conditions: accruing_conditions,
      balance: -1,
      calendar_color: '',
      font_color: '',
      calendar_code: '',
      name: '',
      description: '',
      long_description: '',
      comment: '',
      french_description: '',
      french_long_description: '',
      french_comment: '',
    },
    validationSchema: formSchema,
    validateOnChange: false,
    onSubmit: (data) => {
      submitData(data);
    },
  });

  const submitData = (data: any) => {
    if (isLoading) return;
    setIsLoading(true);
    setErrorName(null);

    const submitData = { ...data };

    if (data.accruing_type === 'free') {
      if (data.balance <= 0) {
        formik.setFieldError('balance', 'Accrued entitlement is required');
        errorType(
          'Missing or incorrect information',
          'You must specify at least one description for this value',
        );
        setTimeout(() => {
          setIsLoading(false);
        }, 1000);
        return;
      } else {
        const value = data.balance || '';
        const split = value.split('');
        const findIndex = split.findIndex((item) => item === '.');
        if (findIndex > 0) {
          const isValid = value.substr(findIndex + 1, value.length - findIndex);

          if (+isValid % 5 !== 0) {
            formik.setFieldError('balance', 'The decimal part must be 0 or 5');
            errorType(
              'Missing or incorrect information',
              'The decimal part must be 0 or 5',
            );
            setTimeout(() => {
              setIsLoading(false);
            }, 1000);
            return;
          }
        }

        delete submitData.accruing_conditions;
      }
    } else {
      if (data?.accruing_conditions.every((item) => !item.reset_counter)) {
        errorType(
          'Missing or incorrect information',
          'You must have one Reset counters',
        );
        setTimeout(() => {
          setIsLoading(false);
        }, 1000);

        return;
      } else {
        delete submitData.balance;
      }
    }

    createStaffTypes(submitData)
      .then((res) => {
        successNotification(`"${data?.name}"`, null, ' created successfully.');
        formik.resetForm();
        setIsLoading(false);
      })
      .catch((err) => {
        const errorMessage =
          err?.response?.data ||
          'An error occurred while creating absence type';

        const outputObject = Object.fromEntries(
          Object.entries(errorMessage).slice(0, 5),
        );

        const divElements = Object.entries(outputObject).map(([key, value]) => {
          const errorMessage = value[0] ? value[0] : 'This field is required';
          formik.setFieldError(key, ` ${errorMessage}`);

          return (
            <div
              style={{ color: '#E02C2C', fontWeight: 400, fontSize: 14 }}
              key={key}
            >
              {/* {mockKeyStaffLeave[key] ? mockKeyStaffLeave[key] : key} */}
              {` ${errorMessage}`}
            </div>
          );
        });

        error('Missing or incorrect information', divElements);
        setTimeout(() => {
          setIsLoading(false);
        }, 1000);
      });
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <GeneralHeader
        pageTitle="Create a new staff leave types"
        icon="/icons/staff_leave_icon.svg"
        child={
          <div style={{ marginTop: '65px' }}>
            <div
              style={{
                justifyContent: 'flex-end',
                display: 'flex',
              }}
            >
              <button
                // disabled={finalData?.name === ''}
                style={{
                  width: 40,
                  height: 40,
                  background: !formik.dirty ? '#E4E4E4' : '#407FDD',
                  border: !formik.dirty && 'transparent',
                }}
                type="submit"
                className="header-button"
                disabled={!formik.dirty}
              >
                <img src="/icons/save.svg" alt="button" />
              </button>
            </div>
            <Tabs
              defaultActiveKey="1"
              items={[
                {
                  key: '1',
                  label: (
                    <div
                      style={{
                        color: '#0E3063',
                        fontSize: '20px',
                        fontWeight: 600,
                        margin: '0 10px',
                        border: '0px, 0px, 2px, 0px',
                      }}
                    >
                      General
                    </div>
                  ),
                  children: (
                    <AbsenceTypesTab
                      errorName={errorName}
                      data={finalData}
                      addData={addData}
                      formik={formik}
                    />
                  ),
                },
              ]}
            />
            {/* <div style={{
              justifyContent: 'flex-end',
              display: 'flex',
            }}>
              <button
                // disabled={finalData?.name === ''}
                style={{
                  width: 40,
                  height: 40,
                  background: '#407FDD',
                }}
                onClick={() => submitData()}
                className="header-button"
              >
                <img src="/icons/save.svg" alt="button" />
              </button>
            </div> */}
            {/* <div>
              <h2 style={{ height: 58, width: 115, color: "#0E3063", fontSize: "26px", fontWeight: 600, paddingLeft: "7px", paddingRight: "7px", borderBottom: "3px solid #0E3063", paddingBottom: "5px" }} > General</h2>
              <AbsenceTypesTab
                data={accruing_conditions}
                addData={addData}
              />
            </div> */}
          </div>
        }
      />
    </form>
  );
};

export default NewAbsenceTypes;
